import { FC, Props } from "./typings";
import styles from "./styles.module.scss";

const ReceivedByCell: FC<Props> = ({ element }) => {
  return (
    <div className={styles.wrapper}>
      <div>
        {element.ReceivedBy && element.ReceivedBy.length > 0
          ? element.ReceivedBy
          : element.ReceiveDate &&
            element.Receivers &&
            element.Receivers.length > 0
          ? element.Receivers[0].Name
          : ""}
      </div>
    </div>
  );
};

export default ReceivedByCell;
